import styles from "./styles.scss";
import { FC, forwardRef, RefAttributes } from "react";
import clsx from "clsx";
import { TextFieldProps } from "./types";

export const TextField: FC<TextFieldProps & RefAttributes<HTMLInputElement>> =
  forwardRef(
    ({ label, className, labelClassName, type = "text", ...props }, ref) => {
      return (
        <label className={clsx(styles.label, labelClassName)}>
          {label}
          <input
            type={type}
            className={clsx(styles.input, className)}
            ref={ref}
            {...props}
          />
        </label>
      );
    },
  );
